import { Page } from "components/Page";
import { useEffect, useState } from "react";

import "react-tabulator/css/bootstrap/tabulator_bootstrap.min.css";
import "react-tabulator/lib/styles.css";

import { Outlet, useRouteLoaderData } from "react-router-dom";
import { formatPhoneNumber } from "utils/helpers";

import { AliRecord } from "services/ALIRecord.d";

const ALIRecordsView = () => {
  const viewData: AliRecord | any = useRouteLoaderData("view_cpn");
  const editData: AliRecord | any = useRouteLoaderData("edit_cpn");
  const deleteData: AliRecord | any = useRouteLoaderData("delete_cpn");
  const [phone, setPhone] = useState<string>("");

  useEffect(() => {
    if (viewData !== undefined) {
      setPhone(formatPhoneNumber(viewData.CPN));
    } else if (editData !== undefined) {
      setPhone(formatPhoneNumber(editData.CPN));
    } else if (deleteData !== undefined) {
      setPhone(formatPhoneNumber(deleteData.CPN));
    } else {
      setPhone("");
    }
  }, [viewData, editData, deleteData]);

  return (
    <Page
      title={phone}
      parentRoute="/ali-records"
      label="ALI Records"
      breadCrumb={{ id: "cpn", title: phone, active: phone ? true : undefined }}
    >
      <Outlet />
    </Page>
  );
};

export default ALIRecordsView;
